// Lógica pura de banners da home, extraída para teste.
// Banner salvo pode ser string (newName) ou objeto legado { newName, originalName }.
// Banner novo é um File (recém-selecionado).

// Devolve o nome (string) do banner, ou null se o formato for inválido/corrompido
// (ex.: File serializado em JSON virou {} sem newName).
export const toBannerName = (b) => {
  if (typeof b === "string") return b;
  if (b && typeof b.newName === "string") return b.newName;
  return null;
};

// Normaliza a lista carregada para strings válidas, descartando corrompidos.
export const normalizeBanners = (banners) =>
  (banners || []).map(toBannerName).filter(Boolean);

// Resolve a lista final de banners (strings) preservando a ordem.
// - `isNew(item)` indica um arquivo recém-enviado: consome a próxima entrada de
//   `uploaded` (que vem na MESMA ordem dos arquivos novos enviados).
// - itens existentes são normalizados para o nome.
// - entradas inválidas/sem newName são descartadas (filter(Boolean)).
export const resolveBannerNames = (files, uploaded, isNew) => {
  let uploadIdx = 0;
  return (files || [])
    .map((file) => {
      if (!isNew(file)) {
        return toBannerName(file);
      }
      const up = (uploaded || [])[uploadIdx++];
      return up && up.newName ? up.newName : null;
    })
    .filter(Boolean);
};
